import script from "./UploadSingleFileKit.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadSingleFileKit.vue?vue&type=script&lang=ts&setup=true"

import "./UploadSingleFileKit.vue?vue&type=style&index=0&id=2476eb4b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2476eb4b"]])

export default __exports__